
import { Component, OnInit,Input } from '@angular/core';
import { AccessService } from 'app/access.service';
import { MenuMappingService } from 'app/menu-mapping.service';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  access?: boolean;
}
export const ROUTES: RouteInfo[] = [
  { path: 'item_master', title: 'Item Master', icon: 'library_books', class: '' },
  { path: 'store-master', title: 'Store', icon: 'storefront', class: '' },
  { path: 'sku-master', title: 'Stock Keeping Unit', icon: 'library_books', class: '' },
  { path: 'inventory', title: 'Inventory', icon: 'warehouse', class: '' },
];

@Component({  
  selector: 'app-stocksphere-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  userMenus: any[] = [];
  user_id: any;
  @Input() isCollapsed: boolean = false;
  
  constructor(
    private accessService: AccessService,
    private menuMappingService: MenuMappingService
  ) {
    // Get user ID from localStorage
    let userString = localStorage.getItem('data');
    let user = JSON.parse(userString) || {};
    this.user_id = user?.id;
  }

  ngOnInit() {
    this.loadUserMenusAndApplyAccess();
  }

  loadUserMenusAndApplyAccess() {
    // Check if user is superadmin (user_id = 1)
    if (this.user_id === 1) {
      // Superadmin has access to all menus
      this.menuItems = ROUTES.filter(menuItem => menuItem).map(route => {
        route.access = true;
        return route;
      });
      return;
    }

    // For regular users, fetch menu access
    this.accessService.getUserMenusFromConfig().subscribe(
      (menus) => {
        this.userMenus = menus;
        this.applyMenuAccess();
      },
      (error) => {
        console.error('Error fetching user menus:', error);
        // Fallback: show all menus if API fails
        this.menuItems = ROUTES.filter(menuItem => menuItem).map(route => {
          route.access = false;
          return route;
        });
      }
    );
  }

  applyMenuAccess() {
    this.menuItems = ROUTES.filter(menuItem => menuItem).map(route => {
      // Check if user has access to this menu
      const hasAccess = this.menuMappingService.hasMenuAccess(route.path, this.userMenus);
      route.access = hasAccess;
      return route;
    });
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };
}
